import React, { useState } from "react";
import { useAuth } from "./AuthProvider";
import { doc, updateDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { Heading } from "./heading";
import { Text } from "./text";
import { Field, FieldGroup, Label } from "./fieldset";
import { Input } from "./input";
import { showAlert } from "../alertService";
import { UserIcon } from "@heroicons/react/20/solid";

const ACCENT = "#1b4d2e";

const UserProfile = () => {
  const { user, userInfo, setUserInfo } = useAuth();

  const [name, setName] = useState(userInfo?.name || "");
  const [lastName, setLastName] = useState(userInfo?.lastName || "");
  const [phone, setPhone] = useState(userInfo?.phone || "");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) {
      showAlert("El nombre es obligatorio", "error");
      return;
    }

    setSaving(true);
    try {
      const updatedFields = {
        name: name.trim(),
        lastName: lastName.trim(),
        phone: phone.trim(),
        updatedAt: Timestamp.now(),
      };

      await updateDoc(doc(db, "users", user.uid), updatedFields);

      setUserInfo((prev) => ({ ...prev, ...updatedFields }));
      showAlert("Perfil actualizado correctamente", "success");
    } catch (error) {
      console.error("Error updating profile:", error);
      showAlert("Error al actualizar el perfil", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl">
      {/* Header */}
      <div className="flex items-center gap-3 mb-1">
        <UserIcon className="h-6 w-6" style={{ color: ACCENT }} />
        <Heading level={1}>Mi Perfil</Heading>
      </div>
      <Text className="mb-8">
        Consulta y actualiza tu información personal.
      </Text>

      {/* Card */}
      <div className="rounded-xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-700/60 dark:bg-zinc-800/50">
        <FieldGroup>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <Field>
              <Label>Email</Label>
              <Input value={userInfo?.email || ""} disabled />
            </Field>

            <Field>
              <Label>Rol</Label>
              <Input value={userInfo?.role || ""} disabled />
            </Field>

            <Field>
              <Label>Nombre</Label>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nombre"
              />
            </Field>

            <Field>
              <Label>Apellido</Label>
              <Input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Apellido"
              />
            </Field>

            <Field className="sm:col-span-2">
              <Label>Teléfono</Label>
              <Input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Teléfono"
              />
            </Field>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={handleSave}
              disabled={saving}
              className="inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-sm transition disabled:opacity-50"
              style={{ backgroundColor: ACCENT }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#164026")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = ACCENT)}
            >
              {saving ? "Guardando..." : "Guardar cambios"}
            </button>
          </div>
        </FieldGroup>
      </div>
    </div>
  );
};

export default UserProfile;
